module.exports = __webpack_public_path__ + "static/media/Illus-Apple_Wallet@3x.a2efb8ec.png";